"use client";
import type { BlokTextBanner } from "@/storyblok";
import { StoryblokComponent, type BlokProps } from "@frend-digital/storyblok";
import BlokWrap from "../BlokWrap";
import styles from "./TextBanner.module.css";
import { useGlobal } from "@/features/global/GlobalContext";

export const TextBannerBlok = ({
	blok,
	preview,
}: BlokProps<BlokTextBanner> & {
	className?: string;
}) => {
	const {
		data: { colorMap },
	} = useGlobal();

	const colorEntry = colorMap[blok.backgroundColor!] || "";
	return (
		<BlokWrap editable={blok} asChild>
			<div
				className={styles.contentWrapper}
				style={{ backgroundColor: colorEntry.color }}
				data-bg={colorEntry.color}
			>
				<div className={styles.content}>
					<div className={styles.info}>
						<p className={styles.title} style={{ color: colorEntry.foreground }}>
							{blok.text}
						</p>
						{blok.button?.map((button) => (
							<StoryblokComponent key={button._uid} blok={button} preview={preview} />
						))}
					</div>
				</div>
			</div>
		</BlokWrap>
	);
};
